<template>
    <form class="reminder-form form-horizontal" @submit.prevent="registrarCanal()">
        <div class="form-group col-sm-6">
            <label for="canal" class="control-label col-sm-6">Nombre de Canal</label>
            <input type="text" name="nombre_canal" id="canal" v-model="data.canal">
        </div>
        <div class="form-group col-sm-6">
            <label for="estado" class="control-label col-sm-6">Estado</label>
            <el-switch v-model="data.status" on-text="Activo" off-text="Inactivo"></el-switch>
        </div>
        <div class="form-group col-sm-offset-4 col-sm-8">
            <button type="submit" class="btn btn-primary">Guardar</button>
            <a href="/backend/canales-atencion" class="btn btn-default">Cancelar</a>
        </div>
    </form>
</template>
<script>
import ElSwitch from 'element-ui/lib/switch';

export default {
    data() {
        const data = {
            canal: null,
            status: null
        };

        return {
            data: data,
            error: {}
        }
    },
    components: {
        ElSwitch
    },
    methods: {
        registrarCanal(){
            
        }
    }
}
</script>